import { render } from "./BranchDefaultFilter.vue?vue&type=template&id=d65ef736"
import script from "./BranchDefaultFilter?vue&type=script&lang=js&external"
export * from "./BranchDefaultFilter?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__